export const IDENTIFIERS = {
  TOURNAMENTS: 'tournaments',
  USERS: 'users',
  CLUBS: 'clubs',
}

export const resources = {
  [[IDENTIFIERS.TOURNAMENTS]]: {
    name: IDENTIFIERS.TOURNAMENTS,
    url: 'tournaments',
  },
  [[IDENTIFIERS.USERS]]: {
    name: IDENTIFIERS.USERS,
    url: 'users',
  },
  [[IDENTIFIERS.CLUBS]]: {
    name: IDENTIFIERS.CLUBS,
    url: 'clubs',
  },
}

/**
 * Returns the URL according to the resource, or the original parameter if it's not found
 * @param {string} name Resource name
 */
export const getResourceUrl = (name) => {
  if (resources[name]) {
    return resources[name].url
  }
  return name
}

/**
 * Returns the label according to the resource, or the original parameter if it's not found
 * @param {string} name Resource name
 */
export const getResourceLabel = (name) => {
  if (resources[name]) {
    return resources[name].label
  }
  return name
}

export default {
  IDENTIFIERS,
  resources,
  getResourceLabel,
  getResourceUrl,
}
